// Sign-in is owned by the central login project (served under /sign).
// The website no longer collects credentials itself; it redirects there and the
// login project sets the session cookie and sends the user back to `source`.
//
// Same-origin (production, or dev through the /sign proxy): /sign/in
// Separate origin (dev, direct to the login project): set VUE_APP_LOGIN_URL, e.g.
//   VUE_APP_LOGIN_URL=http://localhost:9080/sign/in
const LOGIN_URL = process.env.VUE_APP_LOGIN_URL || '/sign/in';

export function loginUrl(returnTo = '/online_services'): string {
  // a login page on another origin can't resolve a relative return path
  const source = /^https?:\/\//.test(LOGIN_URL) ? `${window.location.origin}${returnTo}` : returnTo;
  return `${LOGIN_URL}?source=${encodeURIComponent(source)}`;
}

export function redirectToLogin(returnTo = '/online_services') {
  window.location.href = loginUrl(returnTo);
}
